import { getExternalCalendarEventQueryConfig } from '@griply/hooks';
import { CalendarEventRef } from '@griply/types';
import { useQuery } from '@tanstack/react-query';
import { getExternalCalendarEvent } from 'shared/services/backend-api';

export { externalCalendarEventQueryKey as queryKey } from '@griply/hooks';

// placeholderData keeps pending from suspending the app shell (global suspense default); isPlaceholderData = loading, resolved null = gone
export const useExternalCalendarEventQuery = (
  eventRef: CalendarEventRef | null,
) => {
  const query = useQuery({
    ...getExternalCalendarEventQueryConfig(eventRef, getExternalCalendarEvent),
    enabled: !!eventRef,
    // the default is !!suspense — a throw would crash the route, not show the retry screen
    throwOnError: false,
    placeholderData: null,
  });

  return {
    ...query,
    details: query.isPlaceholderData ? undefined : query.data,
    isLoadingDetails: !!eventRef && query.isPlaceholderData,
  };
};
